const MAX_MANEUVER_LIMIT = 30;

export default MAX_MANEUVER_LIMIT;
